function isTokenValid(token) {
  if (!token) return false;

  const payload = JSON.parse(atob(token.split('.')[1]));
  const { exp } = payload; // Извлекаем дату истечения токена из payload

  if (!exp) return false;

  const currentTime = Math.floor(Date.now() / 1000); // текущее время в секундах
  return currentTime < exp;
}

export default isTokenValid;
